import { FieldNames } from '@app/origami-api/constants/field-names';
import { OrganizationStatusType } from '@app/origami-api/constants/organization-status';
import { StatusColors } from '@app/shared/ui/simple-components/status/status-models';
import { TopicField, TopicUtils } from '@app/origami-api/utils/topic-utils';
import { StatusColor } from '@tpt/common/general/labels';

const ORGANIZATION_STATUS_TYPE_COLORS: Record<OrganizationStatusType, StatusColors> = {
  [OrganizationStatusType.Pending]: StatusColors.StatusesOrange,
  [OrganizationStatusType.Active]: StatusColors.StatusesGreen,
  [OrganizationStatusType.Inactive]: StatusColors.StatusesGrey,
  [OrganizationStatusType.Proposed]: StatusColors.StatusesBlue,
  [OrganizationStatusType.Approved]: StatusColors.StatusesPastelGreen,
  [OrganizationStatusType.Rejected]: StatusColors.StatusesRed,
};

const ORGANIZATION_STATUS_TYPE_COLOR_NAMES: Record<OrganizationStatusType, StatusColor> = {
  [OrganizationStatusType.Pending]: StatusColor.Orange,
  [OrganizationStatusType.Active]: StatusColor.Green,
  [OrganizationStatusType.Inactive]: StatusColor.Grey,
  [OrganizationStatusType.Proposed]: StatusColor.Blue,
  [OrganizationStatusType.Approved]: StatusColor.PastelGreen,
  [OrganizationStatusType.Rejected]: StatusColor.Red,
};

export function getOrganizationStatusTypeIdFromOrganization(
  org?: { TopicFields?: TopicField[] } | null,
): number | undefined {
  const raw = TopicUtils.getTopicFieldValue(org?.TopicFields ?? [], FieldNames.ClientOrganization.StatusTypeId);
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
}

export function getOrganizationStatusColorFromStatusTypeId(statusTypeId?: number | null): StatusColors {
  return ORGANIZATION_STATUS_TYPE_COLORS[statusTypeId as OrganizationStatusType] ?? StatusColors.StatusesGrey;
}

export function getOrganizationStatusColorFromOrganization(org?: { TopicFields?: TopicField[] } | null): StatusColors {
  const statusTypeId = getOrganizationStatusTypeIdFromOrganization(org);
  return getOrganizationStatusColorFromStatusTypeId(statusTypeId);
}

export function getOrganizationStatusColorNameFromStatusTypeId(statusTypeId?: number | null): StatusColor {
  return ORGANIZATION_STATUS_TYPE_COLOR_NAMES[statusTypeId as OrganizationStatusType] ?? StatusColor.Grey;
}

export function getOrganizationStatusColorNameFromOrganization(
  org?: { TopicFields?: TopicField[] } | null,
): StatusColor {
  const statusTypeId = getOrganizationStatusTypeIdFromOrganization(org);
  return getOrganizationStatusColorNameFromStatusTypeId(statusTypeId);
}
